<template>
  <section class="section">
    <div class="container">
      <ViewSelector :view="view" @change="setView($event)">
        <Title :skipMarginBottom="true">
          Domains
          <Plus @click="showAdd = true"></Plus>
        </Title>
      </ViewSelector>

      <SearchBar
        v-model="tempFilter"
        :id="searchId"
        :selectOnSubmit="true"
        :loading="searching"
        :focus="true"
        @submit="search($event)"
      ></SearchBar>

      <Tips
        v-if="firstLoadDone && $store.state.domain.domains.length !== 0"
        path="domains"
        xKey="dismissedTips"
        property="rightClick"
        :rightClickIconVisible="true"
        >Right-click on a domain name to open the context menu
      </Tips>

      <p
        class="is-italic"
        v-if="firstLoadDone && $store.state.domain.domains.length === 0"
      >
        <i>No Domains.</i>
      </p>

      <div v-if="firstLoadDone && $store.state.domain.domains.length !== 0">
        <View1
          v-if="view == 1"
          :items="filtered"
          @order="dispatchDomainOrder($event)"
          @save="rename($event.domain, $event.text)"
          @cancel="toggleRename($event)"
          @menu="$refs.menu.open($event.e, $event.domain)"
        ></View1>

        <View2
          v-if="view == 2"
          :items="filtered"
          @order="dispatchDomainOrder($event)"
          @save="rename($event.domain, $event.text)"
          @cancel="toggleRename($event)"
          @menu="$refs.menu.open($event.e, $event.domain)"
        ></View2>
        <Paging
          v-show="!searching && firstLoadDone"
          :items="paging.pages"
          :selected="paging.page"
          :size="paging.max"
          @change="setPage($event)"
          @size="setPageMax($event)"
          :hasOptions="true"
          autosave="domains"
        ></Paging>
      </div>
    </div>

    <vue-context ref="menu">
      <template v-if="child.data" slot-scope="child">
        <li v-if="child.data.permission < 16 && child.data.permission">
          <a>
            <i>Too low permissions</i>
          </a>
        </li>

        <li v-if="child.data.permission >= 16 || !child.data.permission">
          <a @click.prevent="toggleRename(child.data)">Rename</a>
        </li>

        <li v-if="child.data.permission >= 256 || !child.data.permission">
          <router-link :to="`/domains/${child.data.uid}/shares`"
            >Manage shares</router-link
          >
        </li>
        <li v-if="child.data.permission >= 128 || !child.data.permission">
          <a
            @click.prevent="
              selected = child.data;
              showDelete = true;
            "
            >Delete</a
          >
        </li>
      </template>
    </vue-context>

    <DomainAdd
      v-if="showAdd"
      v-model="showAdd"
      @success="
        $store.state.domain.domains.length == 1 ? (showGuide = true) : false
      "
    ></DomainAdd>

    <DomainConfirm
      v-if="selected && showDelete"
      v-model="showDelete"
      :domain="selected"
      @hide="selected = null"
      @confirmed="_delete(selected)"
    ></DomainConfirm>

    <StartGuide v-if="step > 0" v-model="showGuide" :step="step"
      ><p v-if="step == 1" class="has-text-centered">
        <a
          @click.stop="
            showGuide = false;
            showAdd = true;
          "
        >
          Click here to create your first domain</a
        >.
      </p>

      <p v-if="step == 2" class="has-text-centered">
        <a @click.stop="showGuide = false">Close this window</a> and click on
        the new domain.
      </p>
    </StartGuide>
  </section>
</template>
<script>
import "vue-context/src/sass/vue-context.scss";
import { postApi } from "@/utils/http";
import { getId } from "@/utils/document";
import { dispatchDomainOrder } from "@/utils/order";

import {
  cancelGroupPackageSchedule,
  connect,
  disconnectComputers,
  disconnect,
} from "@/utils/socket";
import { getStartIndex, getNumbers } from "@/utils/paging";

export default {
  components: {
    Tips: () => import("@/components/main/Tips.vue"),
    Title: () => import("@/components/singles/Title.vue"),
    VueContext: () => import("vue-context"),
    DomainConfirm: () => import("@/components/main/domain/Delete.vue"),
    DomainAdd: () => import("@/components/main/domain/Add.vue"),
    Plus: () => import("@/components/main/Plus.vue"),
    SearchBar: () => import("@/components/main/SearchBar.vue"),
    View1: () => import("@/components/main/domain/View1.vue"),
    View2: () => import("@/components/main/domain/View2.vue"),
    ViewSelector: () => import("@/components/main/ViewSelector.vue"),
    IconText: () => import("@/components/singles/IconText.vue"),
    StartGuide: () => import("@/components/main/user/StartGuide.vue"),
    Paging: () => import("@/components/main/paging/Nav.vue"),
  },
  props: {},
  computed: {
    step() {
      if (this.firstLoadDone) {
        if (this.$store.state.domain.domains.length == 0) return 1;
        else if (this.$store.state.domain.domains.length == 1) return 2;
      }

      return -1;
    },
    view() {
      return this.$store.state.settings.user.domains &&
        this.$store.state.settings.user.domains.view
        ? this.$store.state.settings.user.domains.view
        : 1;
    },
    filtered() {
      let items = this.$store.state.domain.domains;

      if (this.filter && this.filter !== "") {
        items = items.filter((x) =>
          x.friendlyName.toLowerCase().includes(this.filter)
        );
      }

      this.setPages(items);

      if (this.paging.max === -1) return items;
      else {
        return items.slice(
          this.paging.start,
          this.paging.page * this.paging.max
        );
      }
    },
  },
  data() {
    return {
      selected: null,
      showDelete: false,
      showAdd: false,
      saving: false,
      firstLoadDone: false,
      searching: false,
      tempFilter: "",
      filter: "",
      searchId: getId(),
      showGuide: false,
      paging: {
        page: 1,
        max: 15,
        start: 0,
        pages: [],
      },
    };
  },
  async created() {
    try {
      await this.$store.dispatch("settings/getUserSetting", {
        path: "profile",
        xKey: "guides",
      });

      await this.$store.dispatch("domain/fetch");

      await this.$store.dispatch("settings/getUserSetting", {
        path: "domains",
        key: "paging",
      });

      const paging = this.$store.state.settings.user.domains?.paging;
      if (paging && paging.max) this.paging.max = paging.max;

      this.checkGuide();

      this.firstLoadDone = true;
    } catch (err) {
      console.log(err);
      this.$helpers.notify("Error", "Could not get domains.", "danger", 5000);
    }
  },
  methods: {
    setPageMax(size) {
      this.paging.max = size;

      this.setPage(1);
      this.setPages(this.$store.state.domain.domains);
    },
    setPages(items) {
      this.paging.pages = getNumbers(items, this.paging.max);
    },
    setPage(page) {
      this.paging.start = getStartIndex(page, this.paging.max);
      this.paging.page = page;
    },
    checkGuide() {
      if (this.$store.state.domain.domains.length === 0 && this.guideActive())
        this.showGuide = true;
      else if (this.$store.state.domain.domains.length === 0)
        this.showAdd = true;
    },
    guideActive() {
      return (
        this.$store.state.settings.user?.profile?.guides?.getStarted ===
          undefined ||
        this.$store.state.settings.user?.profile?.guides?.getStarted
      );
    },

    setView(view) {
      this.$store.dispatch("settings/setUser", {
        path: "domains",
        key: "view",
        value: view,
      });
    },
    dispatchDomainOrder: dispatchDomainOrder,
    search(searchStr) {
      this.searching = true;

      searchStr = searchStr.trim().toLowerCase();
      this.filter = searchStr;

      this.searching = false;
    },
    toggleRename(domain) {
      this.$store.commit("domain/edit", {
        d: domain,
        obj: { edit: !domain.edit },
      });
    },
    async _delete(domain) {
      await this.$store.dispatch("group/fetch", {
        domainUID: domain.uid,
      });

      await this.$store.dispatch("computer/fetch", {
        domainUID: domain.uid,
      });

      await connect(domain);
      for (const groupItem of this.$store.state.group.groups) {
        const computerUIDs = groupItem.computers.map((x) => x.uid);

        await this.$helpers.wait(2);
        cancelGroupPackageSchedule(groupItem.group.uid, computerUIDs);
        await this.$helpers.wait(2);
        disconnectComputers(computerUIDs);
      }

      disconnectComputers(
        this.$store.state.computer.computers.map((x) => x.uid)
      );
      await this.$helpers.wait(2);

      disconnect();

      this.$store.dispatch("domain/delete", domain);
      this.showDelete = false;
    },

    async rename(domain, text) {
      this.$store.commit("domain/edit", {
        d: domain,
        obj: { saving: true },
      });

      text = text.trim();

      await postApi("set/domainFriendlyName", {
        friendlyName: text,
        domainUID: domain.uid,
      });

      this.$store.commit("domain/edit", {
        d: domain,
        obj: { friendlyName: text, edit: false, saving: false },
      });

      this.saving = false;
    },
  },
};
</script>
